import type { Mutation, MutationCreatePdpSearchSuggestionMailArgs } from '@ab-core/graphql/dist';
import { useMutation } from '@apollo/client';
import { useCallback, useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { CREATE_PDP_SEARCH_SUGGESTION_MAIL } from './gql/createPdpSearchSuggestionMail';

type MutationDataType = Pick<Mutation, 'createPdpSearchSuggestionMail'>;
type ResponseDataType = MutationDataType | undefined;

const onError = getErrorLoggerFunction('createPdpSearchSuggestionMail');

export const useCreatePdpSearchSuggestionMail = () => {
    const [response, setResponse] = useState<ResponseDataType>(undefined);

    const [createPdpSearchSuggestionMail, { loading, error, data }] = useMutation<
        MutationDataType,
        MutationCreatePdpSearchSuggestionMailArgs
    >(CREATE_PDP_SEARCH_SUGGESTION_MAIL, {
        onError
    });

    const outgoingCreatePdpSearchSuggestionMail = useCallback(
        (pdpSearchSuggestionInput: MutationCreatePdpSearchSuggestionMailArgs['pdpSearchSuggestionInput']) => {
            createPdpSearchSuggestionMail({ variables: { pdpSearchSuggestionInput } });
        },
        [createPdpSearchSuggestionMail]
    );

    useEffect(() => {
        if (data) {
            setResponse(data);
        }
    }, [data]);

    return {
        success: !!data,
        error: !!error,
        createPdpSearchSuggestionMail: outgoingCreatePdpSearchSuggestionMail,
        loading,
        response
    };
};
